import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { IVimCoreBlocksStoreNewItem } from '@skyeng/libs/vimbox-core/lesson/blocks';
import { VimCoreBlocksStoreApi } from '@skyeng/libs/vimbox-core/lesson/blocks';
import isNil from 'lodash/isNil';

@Injectable({
  providedIn: 'root',
})
export class SafeBlockApiService extends VimCoreBlocksStoreApi {
  save(params: IVimCoreBlocksStoreNewItem[]): Observable<void> {
    // save в store-blocks данных без key приводит к тому что очереди в кролике забиваются
    // и падают консьюмеры, это некая проверка для того что-бы этого избежать
    if (params?.some(param => isNil(param.key))) {
      return throwError('store-block key must be specified');
    }

    return super.save(params);
  }
}
